/* eslint-disable react/jsx-no-constructed-context-values */

/**
 * Context for working with parental consent flow
 */
import React, { createContext, useState } from 'react'
import { updateUserWithParentalConsent } from '../services/parentalConsent'
import useCounter from '../hooks/useCounter'

export const ConsentContext = createContext()

const initialState = {
  childBirthDate: undefined,
  childRecordNumber: undefined,
  parentSmsCountry: undefined,
  consentValue: undefined, // could be parent record number/email/sms
  consentType: undefined, // 'MRN', 'SMS', 'EMAIL'
}

// consumers should have an array of dialogs that match these steps
export const ConsentSteps = {
  none: 0, // initial hook consumer form/page
  info: 1,
  form: 2,
  smsVerify: 3,
  final: 4,
}

export function ConsentProvider({
  overlay,
  accountView,
  initialStep = ConsentSteps.none,
  initialConsentData = null,
  onCancel = () => {},
  children,
}) {
  const [consentData, setConsentData] = useState(initialConsentData || initialState)
  const updateConsentData = (data) => {
    setConsentData({ ...consentData, ...data })
  }
  const {
    counter: currentStep,
    incrementCounter: goToNextStep,
    resetCounter: resetSteps,
    setCounter: setStep,
  } = useCounter(initialStep)
  const handleSubmitConsent = async (formData) => {
    if (currentStep === ConsentSteps.form) {
      const combinedData = {
        // add in childBirthDate and childRecordNumber
        ...consentData,
        ...formData,
      }
      await updateUserWithParentalConsent(combinedData)
      updateConsentData(formData)
      setStep(combinedData.consentType === 'SMS' ? ConsentSteps.smsVerify : ConsentSteps.final)
    } else {
      goToNextStep()
    }
  }

  const handleCancel = () => {
    overlay.close()
    setTimeout(resetSteps)
    onCancel()
  }

  const value = {
    // overlay and steps
    overlay,
    currentStep,
    resetSteps,
    goToNextStep,
    setStep,
    handleCancel,
    ConsentSteps,
    // data
    accountView,
    consentData,
    updateConsentData,
    handleSubmitConsent,
  }
  return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>
}
